








































































































































































































































import CAvatar from '~/components/shared/configurable/image/avatar/CAvatar.vue'
import { computed, defineComponent, ref, toRefs } from '@nuxtjs/composition-api'
import { Ref } from '@vue/composition-api'
import { useClassifiedForm } from '~/compositions/form'
import { formFieldProps } from '~/constants/form'
import { useDep } from '~/compositions/dependency-container'
import FormValidationBuilder from '~/builders/form/FormValidationBuilder'
import FieldError from '~/components/car/classifieds/form/fieldsets/fields/FieldError.vue'
import CNewBadge from '~/components/shared/configurable/badge/CNewBadge.vue'
import FieldHandlerContainer from '~/components/car/classifieds/form/fieldsets/fields/FieldHandlerContainer.vue'
import { LegacyUrlService } from '~/services/legacy/url/LegacyUrlService'
import CConfirmationModal from '~/components/shared/configurable/modal/CConfirmationModal.vue'
import { useNamespacedStore } from '~/compositions/store'
import { USER_NS, UserState } from '~/store/modules/shared/user/state'
import { ciTimes } from '~/icons/source/regular/times'

export default defineComponent({
  props: formFieldProps,
  components: {
    CConfirmationModal,
    FieldHandlerContainer,
    CNewBadge,
    FieldError,
    CAvatar
  },
  setup(props) {
    const { specs, name } = toRefs(props)
    const financeEnabled = ref<boolean>(false)
    const defaultValuesOverride = ref<boolean>(false)

    const interest = ref<number | null>(null)
    const interestError = ref<string | null>(null)

    const minDownpayment = ref<number | null>(null)
    const minDownpaymentError = ref<string | null>(null)

    const maxInstallments = ref<number | null>(null)
    const maxInstallmentsError = ref<string | null>(null)
    const showConfirmModal = ref<boolean>(false)

    const legacyUrlService = useDep(LegacyUrlService)
    const { getters: userGetters } = useNamespacedStore<UserState>(USER_NS)

    function onValue(v: Ref<any>) {
      financeEnabled.value = v.value?.finance
      interest.value =
        v.value?.interest || v.value?.interest === 0 ? v.value?.interest : null
      minDownpayment.value =
        v.value?.min_down_payment || v.value?.min_down_payment === 0
          ? v.value?.min_down_payment
          : null
      maxInstallments.value =
        v.value?.max_installments || v.value?.max_installments === 0
          ? v.value?.max_installments
          : null

      defaultValuesOverride.value = Boolean(
        interest.value || minDownpayment.value || maxInstallments.value
      )
    }

    function onError(e: Ref<any>) {
      interestError.value = e.value?.interest || null
      minDownpaymentError.value = e.value?.min_down_payment || null
      maxInstallmentsError.value = e.value?.max_installments || null
    }
    const { valueChanged, debouncedValueChanged } = useClassifiedForm(props, {
      onValue,
      onError
    })
    const formValidationBuilder = useDep(FormValidationBuilder)

    const handleFinanceEnabledChange = (accepts: boolean) => {
      financeEnabled.value = accepts
      if (!accepts) {
        interest.value = null
        maxInstallmentsError.value = null
        minDownpaymentError.value = null
        emitValues()
        debouncedValueChanged(name.value, null)
      } else {
        emitValues()
      }
    }

    const validateInterest = (text: string) => {
      const textAsNum = Number(text)
      formValidationBuilder
        .new(interestError)
        .required(specs.value?.interest.required, textAsNum)
        .aboveMinNumber(specs.value?.interest.min, textAsNum)
        .belowMaxNumber(specs.value?.interest.max, textAsNum)
        .validate()
    }

    const handleInterestInput = (text: string) => {
      validateInterest(text)
      emitValues()
    }

    const validateMinDownpayment = (text: string) => {
      const textAsNum = Number(text)
      formValidationBuilder
        .new(minDownpaymentError)
        .required(specs.value?.min_down_payment.required, textAsNum)
        .aboveMinNumber(specs.value?.min_down_payment.min, textAsNum)
        .belowMaxNumber(specs.value?.min_down_payment.max, textAsNum)
        .validate()
    }

    const handleMinDownpaymentInput = (text: string) => {
      validateMinDownpayment(text)
      emitValues()
    }
    const validateMaxInstallments = (text: string) => {
      const textAsNum = Number(text)
      formValidationBuilder
        .new(maxInstallmentsError)
        .required(specs.value?.max_installments.required, textAsNum)
        .isNumeric(textAsNum)
        .aboveMinNumber(specs.value?.max_installments.min, textAsNum)
        .belowMaxNumber(specs.value?.max_installments.max, textAsNum)
        .validate()
    }

    const handleMaxInstallmentsInput = (text: string) => {
      validateMaxInstallments(text)
      emitValues()
    }

    const emitValues = () => {
      if (!financeEnabled.value) {
        valueChanged('is_financed', false)
        debouncedValueChanged(name.value, null)
        return
      }
      valueChanged('is_financed', true)
      debouncedValueChanged(name.value, {
        finance: true,
        interest:
          interest.value || interest.value === 0
            ? Number(interest.value)
            : null,
        min_down_payment:
          minDownpayment.value || minDownpayment.value === 0
            ? Number(minDownpayment.value)
            : null,
        max_installments:
          maxInstallments.value || maxInstallments.value === 0
            ? Number(maxInstallments.value)
            : null
      })
    }

    const disableOverride = () => {
      if (
        interest.value ||
        interest.value === 0 ||
        minDownpayment.value ||
        minDownpayment.value === 0 ||
        maxInstallments.value ||
        maxInstallments.value === 0
      ) {
        showConfirmModal.value = true
        return
      }

      defaultValuesOverride.value = false
    }

    const storeUrl = computed(() => {
      return legacyUrlService.getAccountStoresUrl(
        userGetters('userDealerIds').length > 1 && specs.value?.old_dealer_id
          ? `#dealer-${specs.value.old_dealer_id}`
          : '#finance'
      )
    })

    const onEraseConfirm = () => {
      defaultValuesOverride.value = false

      interest.value = null
      minDownpayment.value = null
      maxInstallments.value = null
      emitValues()
    }

    return {
      financeEnabled,
      handleFinanceEnabledChange,
      defaultValuesOverride,
      disableOverride,
      interest,
      interestError,
      minDownpayment,
      minDownpaymentError,
      maxInstallments,
      maxInstallmentsError,
      emitValues,
      handleInterestInput,
      handleMinDownpaymentInput,
      handleMaxInstallmentsInput,
      storeUrl,
      showConfirmModal,
      onEraseConfirm,
      ciTimes
    }
  }
})
